<template>
  <v-container fluid>
    <div>
      <assign-digi-board-time-slot
        v-if="showForm"
        @success="getDigiBoardTimeSlotsList"
        @closed="showForm = false"
      />
      <edit-digi-board-time-slot
        v-if="showEditForm"
        :digiboardtimeslotdetails="editDigiBoardTimeSlotDetails"
        @success="getDigiBoardTimeSlotsList"
        @closed="showEditForm = false"
      />
    </div>
    <br>
    <v-row>
      <v-col
        cols="12"
        md="9"
      >
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-clipboard-text-clock-outline
          </v-icon> DigiBoard Time Slots
        </h2>
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="digiboard-details"
      >
        <p class="p-style">
          Total Duration:-
          <font
            class="total-duration"
          >
            {{ digiBoardDetails.total_duration }} Sec*
          </font>
        </p>
        <p class="p-style">
          Available Duration:-
          <font
            class="available-duration"
          >
            {{ totalAvailableDuration }} Sec
          </font>
        </p>
      </v-col>
    </v-row>
    <v-alert
      v-if="isSlotLimitReached"
      text
      prominent
      type="warning"
      color="red"
      border="left"
      class="authorization-alert"
    >
      Reached total duration limit. Delete an existing slot before assigning a new one.
    </v-alert>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          :disabled="isSlotLimitReached"
          @click="assignTimeSlot()"
        >
          Assign New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="digiBoardTimeSlots"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>
              {{ item.duration }}
            </td>
            <td>
              {{ item.type }}
            </td>
            <td>
              <font
                :color="getColor(item.purchase_status)"
                class="font-my-style"
              >
                {{ item.purchase_status | statusUpdate }}
              </font>
            </td>
            <td>{{ item.created_at | convertStringToLocalDatetime }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="getPriceDetails(item.digi_board_time_slot_id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click="editDigiBoardTimeSlot(item)"
              >
                <v-icon> mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="red"
                @click.stop
                @click="deleteDigiBoardTimeSlot()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import AssignDigiBoardTimeSlot from './AssignDigiBoardTimeSlot.vue';
  import EditDigiBoardTimeSlot from './EditDigiBoardTimeSlot.vue';

  export default {
    name: 'DigiBoardTimeSlots',
    components: {
      'centre-spinner': spinner,
      'assign-digi-board-time-slot': AssignDigiBoardTimeSlot,
      'edit-digi-board-time-slot': EditDigiBoardTimeSlot,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'sold') return 'Sold';
        else return 'Unsold';
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Duration', value: 'duration' },
          { text: 'Type', value: 'type' },
          { text: 'Status', value: 'purchase_status' },
          { text: 'Assigned At', value: 'created_at' },
          { text: 'Prices', value: 'prices' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        showForm: false,
        showEditForm: false,
        editDigiBoardTimeSlotDetails: {},
      };
    },
    computed: {
      digiBoardDetails () {
        const digiboardTimeSlotsList = this.$store.getters['digiboards/getDigiBoardsList'];
        const digiBoardId = this.$route.params.id;
        const digiboardDetails = digiboardTimeSlotsList.filter(item => item.external_id === digiBoardId);
        return digiboardDetails[0];
      },
      digiBoardTimeSlots () {
        const digiboardTimeSlotsList = this.$store.getters['digiboards/getDigiBoardTimeSlotsList'];
        if (digiboardTimeSlotsList.length > 0) {
          const timeSlotsList = digiboardTimeSlotsList[0].time_slots;
          return timeSlotsList;
        }
        return [];
      },
      isSlotLimitReached () {
        var totalAssignedSlotsDuration = this.digiBoardTimeSlots.reduce((accum, item) => accum + item.duration, 0);
        if (this.digiBoardDetails.total_duration === totalAssignedSlotsDuration) {
          return true;
        }
        return false;
      },
      totalAvailableDuration () {
        var totalDuration = this.digiBoardDetails.total_duration;
        var totalAssignedSlotsDuration = this.digiBoardTimeSlots.reduce((accum, item) => accum + item.duration, 0);
        var availableDuration = totalDuration - totalAssignedSlotsDuration;
        return availableDuration;
      },
    },
    async mounted () {
      await this.getDigiBoardTimeSlotsList();
    },
    methods: {
      async getDigiBoardTimeSlotsList () {
        const digiBoardId = this.$route.params.id;
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchDigiBoardTimeSlotsList', {
          digiBoard: digiBoardId,
        });
        this.loading = false;
      },
      deleteDigiBoardTimeSlot () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Sorry you are not authorized to delete any time slots from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      getColor (status) {
        if (status === 'sold') return '#C62828';
        else return '#2E7D32';
      },
      assignTimeSlot () {
        this.showForm = true;
      },
      editDigiBoardTimeSlot (timeSlotdetails) {
        this.editDigiBoardTimeSlotDetails = timeSlotdetails;
        this.showEditForm = true;
      },
      getPriceDetails (digiBoardTimeSlotId) {
        const externalId = this.$route.params.id;
        this.$router.push(`/digi-boards/${externalId}/time-slots/${digiBoardTimeSlotId}/products`);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table {
  background-color: #ECEFF1;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.authorization-alert {
  font-family: 'Times New Roman', Times, serif;
  font-size: 16px;
  margin-top: 25px;
}
.font-style {
  font-weight: bold;
  font-size: 17px;
  color: #37474F;
}
.p-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  margin-bottom: 5px;
}
.total-duration {
  font-weight: bold;
  font-size: 17px;
  color: #2E7D32;
}
.available-duration {
  font-weight: bold;
  font-size: 17px;
  color: #C62828;
}
.digiboard-details {
  border: 2px solid #CFD8DC;
  border-radius: 15px;
}
</style>
